import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { CallTimeListView } from "@/components/call-time/call-time-list-view";
import { DonorDetailModal } from "@/components/fundraising/DonorDetailModal";
import { useSession } from "@/hooks/use-session";

function toId(v: unknown): number | undefined {
	const n = Number(v);
	return Number.isFinite(n) && n > 0 ? n : undefined;
}

export const Route = createFileRoute("/_app/_/call-time/")({
	component: CallTimeIndexPage,
	// `?contactId` opens the (prospect) donor-detail modal over the call
	// list — same modal as Donors — so refresh / back / shared links work.
	// Optional so existing `to="/call-time"` links need no search prop.
	validateSearch: (search: Record<string, unknown>): { contactId?: number } => {
		const contactId = toId(search.contactId);
		return contactId !== undefined ? { contactId } : {};
	},
});

function CallTimeIndexPage() {
	const session = useSession();
	const campaignId = session.campaign?.id;
	const navigate = useNavigate({ from: Route.fullPath });
	const { contactId } = Route.useSearch();

	if (!campaignId) {
		return (
			<div className="flex min-h-[50vh] items-center justify-center">
				<p className="text-muted-foreground">Loading campaign...</p>
			</div>
		);
	}

	return (
		<>
			<CallTimeListView
				campaignId={campaignId}
				onOpenContact={(cid) => navigate({ search: { contactId: cid } })}
			/>
			<DonorDetailModal
				campaignId={campaignId}
				contactId={contactId}
				open={contactId != null}
				onOpenChange={(o) => {
					if (!o) navigate({ search: { contactId: undefined } });
				}}
			/>
		</>
	);
}
